export default __webpack_public_path__ + "static/media/undraw_feeling_blue.a1688c2f.svg";